var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CloudDone50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M47.9,30.55C47.19,35.47,42.79,39,37.87,39H10.14c-4.93,0-9.33-3.53-10.04-8.45 c-0.87-6.14,3.82-11.4,9.73-11.4c0.04,0,0.08,0.01,0.12,0.01C11.94,13.25,17.47,9,24,9c4.62,0,8.75,2.13,11.46,5.47 c1.1,1.34,1.96,2.87,2.53,4.54c0.03,0.05,0.04,0.1,0.06,0.15c0.04,0,0.08-0.01,0.12-0.01C44.08,19.15,48.77,24.42,47.9,30.55z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.882,
    height: 5,
    x: 17.004,
    y: 19.52,
    fill: "#6c19ff",
    transform: "rotate(-45.001 31.444 22.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M37.99,19.01c-0.57-1.67-1.43-3.2-2.53-4.54L23.001,26.929l-5.61-5.61l-3.535,3.536L23,34 l0.001-0.001L23.001,34L37.99,19.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CloudDone50);
export default __webpack_public_path__ + "static/media/icons8-cloud-done-50.1e97937a2c3576a839aae655201d5db8.svg";
export { ForwardRef as ReactComponent };